import { ColumnHelper } from "PFComponents/table/table.types";
import { BasicProfile } from "PFTypes";

import { WorkforceMemberCell } from "./workforce_member_cell";
import css from "./workforce_member_cell.module.scss";

export const createWorkforceMemberColumn = (columnHelper: ColumnHelper<BasicProfile>) =>
  columnHelper.accessor((row) => row, {
    id: "workforceMember",
    header: "",
    cell: (info) => <WorkforceMemberCell profile={info.getValue()} />,
    enableSorting: false,
    size: 450,
    meta: {
      cellClassName: css.cell
    }
  });
